module.exports = __webpack_public_path__ + "static/media/esperando.1af1e6da.png";